export default require('../../client/death/search/SearchPage').default;
